import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { StoredDocumentsListCategoryFilterComponent } from "@app/views/stored-documents/stored-documents-list-category-filter/stored-documents-list-category-filter.component";
import { StoredDocumentsListItemComponent } from "@app/views/stored-documents/stored-documents-list-item/stored-documents-list-item.component";
import { StoredDocumentsListSortComponent } from "@app/views/stored-documents/stored-documents-list-sort/stored-documents-list-sort.component";
import { TranslateModule } from "@ngx-translate/core";
import { StoredDocumentSortings } from "@shared/enums/stored-document-sortings.type";
import { StoredDocumentCategory } from "@shared/models/stored-document-category.model";
import { StoredDocument } from "@shared/models/stored-document.model";
import { ProgressSpinnerModule } from "primeng/progressspinner";

@Component({
  selector: "app-stored-documents-list",
  standalone: true,
  imports: [
    CommonModule,
    ProgressSpinnerModule,
    StoredDocumentsListItemComponent,
    StoredDocumentsListCategoryFilterComponent,
    StoredDocumentsListSortComponent,
    TranslateModule,
  ],
  templateUrl: "./stored-documents-list.component.html",
  host: { class: "flex flex-col" },
})
export class StoredDocumentsListComponent {
  @Input() documents: StoredDocument[] | undefined = undefined;
  @Input() categories: StoredDocumentCategory[] | undefined = undefined;
  @Output() downloadDocumentAction = new EventEmitter<StoredDocument>();
  @Output() editDocumentAction = new EventEmitter<StoredDocument>();
  @Output() deleteDocumentAction = new EventEmitter<StoredDocument>();
  @Output() editListEventEmitter = new EventEmitter<boolean>();

  categoryFilter: StoredDocumentCategory | undefined;
  defaultSorting: StoredDocumentSortings;
  sorting: StoredDocumentSortings;

  constructor() {
    this.defaultSorting = this.sorting = StoredDocumentSortings.UploadDateAscending;
  }

  get processedDocuments(): StoredDocument[] | undefined {
    if (this.documents === undefined) return undefined;

    return this.documents
      .filter((doc: StoredDocument) => this.categoryFilter === undefined || doc.category === this.categoryFilter.name)
      .sort(this.getDocumentSortingProcess(this.sorting));
  }

  getDocumentSortingProcess(sorting: StoredDocumentSortings): (docA: StoredDocument, docB: StoredDocument) => number {
    switch (sorting) {
      case StoredDocumentSortings.NameAscending:
        return (a, b) => a.name.localeCompare(b.name);
      case StoredDocumentSortings.NameDescending:
        return (a, b) => b.name.localeCompare(a.name);
      case StoredDocumentSortings.UploadDateAscending:
        return (a, b) => b.uploadDate.getTime() - a.uploadDate.getTime();
      case StoredDocumentSortings.UploadDateDescending:
        return (a, b) => a.uploadDate.getTime() - b.uploadDate.getTime();
      case StoredDocumentSortings.CategoryNameAscending:
        return (a, b) => a.category.localeCompare(b.category);
      case StoredDocumentSortings.CategoryNameDescending:
        return (a, b) => b.category.localeCompare(a.category);
      default:
        return (a, b) => 1;
    }
  }

  get sortAndFilterResetVisible(): boolean {
    return this.categoryFilter !== undefined || this.sorting !== this.defaultSorting;
  }

  resetSortAndFilter() {
    this.categoryFilter = undefined;
    this.sorting = this.defaultSorting;
  }

  onDownload(document: StoredDocument) {
    this.downloadDocumentAction.emit(document);
  }

  onEdit(document: StoredDocument) {
    this.editDocumentAction.emit(document);
  }

  onDelete(documentId: StoredDocument) {
    this.deleteDocumentAction.emit(documentId);
  }

  editCategoryEvent(event: boolean) {
    this.editListEventEmitter.emit(event);
  }
}
